import React, {useContext, useEffect, useRef, useState} from "react";
import {Badge} from "primereact/badge";
import {useHistory, useParams} from 'react-router-dom';
import {TranslateContext} from "../../../context/TranslateContext";
import Translate from "../../../components/Translate";
import {AuthContext} from "../../../context/AuthContext";
import TabellaDocumentiKpiController from "./components/TabellaDocumentiKpiController";
import CommentiKpiController from "../../../features/commenti/CommentiKpiController";
import {
    aggiornaValoriTabellaKpiApi,
    getKpiByIdAndTipoApi,
    getStrutturaKpiApi
} from "../services/KpiServices";
import InfoKpiView from "./InfoKpiView";
import DatiGeneraliKpi from "./components/DatiGeneraliKpi";
import StoricoModificheKpiController from "./components/StoricoModificheKpiController";

export default function InfoKpiController() {
    const {id, idTipoImport} = useParams();

    const [kpi, setKpi] = useState();
    const [keyTab, setKeyTab] = useState(0);
    const [countUpdateDocumenti, setCountUpdateDocumenti] = useState(0);
    const [countUpdateCommenti, setCountUpdateCommenti] = useState(0);
    const [show, setShow] = useState(false);
    const [showModalDocumentoKpi, setShowModalDocumentoKpi] = useState(false);
    const [showModalCommentoKpi, setShowModalCommentoKpi] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [strutturaKpi, setStrutturaKpi] = useState([]);

    const history = useHistory();

    const formikRef = useRef();
    const {translate, lingua, loadingNewLang} = useContext(TranslateContext);
    const {annoKpi} = useContext(AuthContext);

    async function getKpi() {
        const response = await getKpiByIdAndTipoApi(id, idTipoImport);
        setKpi(response.data.data);
    }

    async function getStrutturaKpi() {
        const response = await getStrutturaKpiApi(id, `?val=1&id_tipo_imp_dati=${idTipoImport}`);
        setStrutturaKpi(response.data.data);
    }

    useEffect(() => {
        if (loadingNewLang === false) {
            if (id && id !== '' && id !== null && idTipoImport && idTipoImport !== '') {
                getKpi();
                getStrutturaKpi();
            } else {
                setKpi(null);
                setStrutturaKpi(null);
            }
        }
    }, [lingua, id, annoKpi, idTipoImport, loadingNewLang]);

    function getHtmlFromTestoMd(testo) {
        if (testo && testo !== '') {
            return testo.split('\n').map((riga, idx) => {
                if (riga.startsWith('### ')) {
                    return <strong key={idx} className="mt-2 mb-4">{riga.replace('### ', '')}</strong>;
                } else if (riga.startsWith('## ')) {
                    return <h6 key={idx} className="mt-4" style={{color: "royalblue"}}>{riga.replace('## ', '')}</h6>;
                } else if (riga.startsWith('# ')) {
                    return <h4 key={idx} className="mt-4">{riga.replace('# ', '')}</h4>;
                } else if (riga.trim() !== '') {
                    return <p key={idx}>{riga}</p>;
                }
            });
        }
    }

    async function aggiornaValoriTabellaKpi(tabella) {
        const response = await aggiornaValoriTabellaKpiApi(id, tabella);
        if (response.data.result === 0) {
            setStrutturaKpi(response.data.data);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const scrollableTabs = [{
        title: translate("Generale"), content: strutturaKpi &&
            <DatiGeneraliKpi
                formikRef={formikRef}
                strutturaKpi={strutturaKpi}
                aggiornaValoriTabellaKpi={aggiornaValoriTabellaKpi}
            />
    }, {
        title: <React.Fragment>
            <Translate>Commenti</Translate>{kpi && kpi.num_commenti !== '' && kpi.num_commenti > 0 && ' *'}&nbsp;
            {kpi && kpi.num_commenti_nuovi !== '' && kpi.num_commenti_nuovi > 0 &&
                <Badge value={kpi.num_commenti_nuovi} severity="danger"/>}
        </React.Fragment>,
        content: <CommentiKpiController
            idKpi={id}
            idTipoImportDati={idTipoImport}
            countUpdate={countUpdateCommenti}
            updateKpiCompPadre={() => {
                getKpi()
            }}
            parentTab={'commenti'}
            parentPaginaTab={'InfoOdl'}
        />
    }, {
        title: <React.Fragment>
            <Translate>Documenti</Translate>{kpi && kpi.num_documenti !== '' && kpi.num_documenti > 0 && ' *'}
        </React.Fragment>,
        content: <TabellaDocumentiKpiController
            idKpi={id}
            idTipoImportDati={idTipoImport}
            onDeleteDocumento={getKpi}
            countUpdate={countUpdateDocumenti}
        />
    }, {
        title: translate("Revisioni"), content:
            <StoricoModificheKpiController
                idKpi={id}
                idTipoImportDati={idTipoImport}
            />
    }, kpi && kpi.testo_glossario && kpi.testo_glossario !== '' && {
        title: translate("Glossario"),
        content: <div className={"row"} key={"glossario"}>
            <div className={"col-md-12"}>
                {getHtmlFromTestoMd(kpi.testo_glossario)}
            </div>
        </div>
    }];

    function handleOkModalDocumento() {
        // Aggiorno il KPI in modo da ottenere il nuovo numero di documenti
        getKpi();
        setCountUpdateDocumenti(countUpdateDocumenti + 1);

        // Chiudo la modale
        setShowModalDocumentoKpi(false);
    }

    function handleOkModalCommento() {
        // Aggiorno il KPI in modo da ottenere il nuovo numero di commenti
        getKpi();
        setCountUpdateCommenti(countUpdateCommenti + 1);

        // Chiudo la modale
        setShowModalCommentoKpi(false);
    }

    return kpi && (
        <InfoKpiView
            show={show}
            idTipoImport={idTipoImport}
            history={history}
            setShow={setShow}
            modalMsg={modalMsg}
            id={id}
            kpi={kpi}
            keyTab={keyTab}
            setKeyTab={setKeyTab}
            translate={translate}
            scrollableTabs={scrollableTabs}
            setShowModalCommentoKpi={setShowModalCommentoKpi}
            setShowModalDocumentoKpi={setShowModalDocumentoKpi}
            showModalCommentoKpi={showModalCommentoKpi}
            showModalDocumentoKpi={showModalDocumentoKpi}
            handleOkModalDocumento={handleOkModalDocumento}
            handleOkModalCommento={handleOkModalCommento}
        />
    );
}